import React from "react";

const WORKING_AREAS =
  "Distributed platforms · Real-time data · Production backends · Infrastructure";

const TransmissionSignal = () => {
  return (
    <div
      className="dossier-transmission"
      role="group"
      aria-label="Working areas"
    >
      <p className="transmission-readable">{WORKING_AREAS}</p>
      <div className="transmission-window" aria-hidden="true">
        <div className="transmission-track">
          <span className="transmission-copy">{`${WORKING_AREAS} ·`}</span>
          <span className="transmission-copy">{`${WORKING_AREAS} ·`}</span>
        </div>
      </div>
    </div>
  );
};

export default TransmissionSignal;
